import { LevelValueEnum, MarkTypeEnum } from './types';
import type { ClassificationMark } from './types';

/**
 * Portion marks that are valid on their own (not a classification level + compartments).
 * Shared between the parser (to produce the mark object) and extractMarks
 * (to recognize the substring as a portion mark).
 *
 * Keys are the portion-mark text (uppercase); values are the parser output.
 */
const standaloneMarks: Record<string, ClassificationMark> = {
  CUI: {
    type: MarkTypeEnum.DOMESTIC,
    classificationLevel: LevelValueEnum.UNCLASSIFIED,
    cui: true,
  },
  E: {
    type: MarkTypeEnum.DOMESTIC,
    classificationLevel: LevelValueEnum.UNCLASSIFIED,
    exercise: true,
  },
  DCNI: {
    type: MarkTypeEnum.DOMESTIC,
    classificationLevel: LevelValueEnum.UNCLASSIFIED,
    dcni: true,
  },
};

export default standaloneMarks;
